import { render, staticRenderFns } from "./ShareBar.vue?vue&type=template&id=d20f53e4&scoped=true&"
import script from "./ShareBar.vue?vue&type=script&lang=js&"
export * from "./ShareBar.vue?vue&type=script&lang=js&"
import style0 from "./ShareBar.vue?vue&type=style&index=0&id=d20f53e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20f53e4",
  null
  
)

export default component.exports